import {
	Directive,
	Input,
	HostListener
} from '@angular/core';

@Directive({
	selector: '[smScroll]',
	exportAs: 'smScroll',
	host: {
		'(click)': 'scroll()'
	}
})
export class SmScrollDirective {
	@Input('smScroll') mode: 'top';
	private _timer: any;

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		if (window) {
			window.clearTimeout(this._timer);
		}
	}

	scroll() {
		switch (this.mode) {
			case 'top':
				if (window) {
					let top = window.pageYOffset;
					let step = top / 50;
					if (step < 50) {
						step = 50;
					}

					const fnc = () => {
						top = top - step;
						if (top < 0) {
							top = 0;
						}
						window.scrollTo(0, top);
						if (top > 0) {
							this._timer = setTimeout(fnc, 20);
						}
					};

					fnc();
				}
				break;
		}
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/directives/sm-scroll.directive.ts